import type { ReactNode } from "react";
import { usePermissions, type PermissionContext } from "@/hooks/usePermissions";
import type { Permission } from "@/constants/permissions";

interface PermissionGuardProps {
  permission: Permission;
  context?: PermissionContext;
  fallback?: ReactNode;
  children: ReactNode;
}

export function PermissionGuard({
  permission,
  context,
  fallback = null,
  children,
}: PermissionGuardProps) {
  const { hasPermission } = usePermissions();

  if (!hasPermission(permission, context)) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
}
